import React, {useContext} from 'react'
import {ProductContext} from "../../../../../pages/ProductStencil";
import {BenefitLabel} from "../../../common/BenefitLabel";

export const Benefits = () => {
    const {product} = useContext(ProductContext);
    const {benefits} = product.tags;
    const isNoData = !benefits.length;

    return (
        <div className={`${isNoData ? 'accordion__benefits no-data' : 'accordion__benefits'}`}>
            {benefits.map((benefit, index) => (
                <BenefitLabel benefit={benefit} key={index} />
            ))}
        </div>
    )
}
